module.exports = __webpack_public_path__ + "img/DRmed-02.16914ee9.png";